import { Injectable } from '@angular/core';
import * as firebase from 'firebase';

@Injectable()
export class FiltersService {

  constructor() { }

  /**
   * @param role 
   * role = 1 => miembro
   * role = 2 => ministro
   * role = 3 => superAdmin
   */
  async getUsersByRole(role) {
    const result = await  firebase.firestore().collection('users').where('rol', '==', role).get();
    const vector = []
    if (!result.empty) {
      result.docs.forEach((data) => {
        console.log(data.data());
        vector.push(data.data())
      })
    }
    return vector
  }  

  /**
   * @param district 
   * @param sectional 
   * 
   * district = 1 => Norte
   * district = 2 => Centro
   * district = 3 => Occidente
   * 
   * sectional = 1 => ?
   */
  async getChurchesByDistrictAndSectional(district, sectional) {
    const result = await  firebase.firestore().collection('churches')
                            .where('distrito', '==', district).where('seccional', '==', sectional).get();
    const vector = []
    if (!result.empty) {
      result.docs.forEach((data) => {
        console.log(data.data());
        vector.push(data.data())
      })
    }
    return vector
  }    

  /**
   * @param district 
   * 
   * district = 1 => Norte
   * district = 2 => Centro
   * district = 3 => Occidente
   */
  async getChurchesByDistrict(district) {
    const result = await  firebase.firestore().collection('churches').where('distrito', '==', district).get();
    const vector = []
    if (!result.empty) {
      result.docs.forEach((data) => {
        console.log(data.data());
        vector.push(data.data())
      })
    }
    return vector
  }   

  /**
   * @param sectional 
   * sectional = 1 => ?
   */
  async getChurchesBySectional(sectional) {
    const result = await  firebase.firestore().collection('churches').where('seccional', '==', sectional).get();
    const vector = []
    if (!result.empty) {
      result.docs.forEach((data) => {
        console.log(data.data());
        vector.push(data.data())
      })
    }
    return vector
  }   

}



// WEBPACK FOOTER //
// ./src/app/services/filters/filters.service.ts